import _Object$keys from "/app/node_modules/babel-runtime/core-js/object/keys";
import _Object$assign from "/app/node_modules/babel-runtime/core-js/object/assign";
import _slicedToArray from "/app/node_modules/babel-runtime/helpers/slicedToArray";
import _Object$entries from "/app/node_modules/babel-runtime/core-js/object/entries";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
export default {
  getSignedURL: function getSignedURL(file, config) {
    var payload = {
      filePath: file.name,
      contentType: file.type
    };
    console.log("GETSIGNED-URL-ENTRE");
    return new _Promise(function (resolve, reject) {
      var fd = new FormData();
      var request = new XMLHttpRequest(),
          signingURL = typeof config.signingURL === "function" ? config.signingURL(file) : config.signingURL;
      console.log("SIGNINURL ", signingURL);
      request.open("POST", signingURL);
      request.onload = function () {
        if (request.status == 200) {
          resolve(JSON.parse(request.response));
        } else {
          reject(request.statusText);
        }
      };
      request.onerror = function (err) {
        console.error("Network Error : Could not send request to AWS (Maybe CORS errors)");
        reject(err);
      };
      if (config.withCredentials === true) {
        request.withCredentials = true;
      }
      _Object$entries(config.headers || {}).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        console.log("NAME ", name);
        console.log("VALUE ", value);
        request.setRequestHeader(name, value);
      });
      payload = _Object$assign(payload, config.params || {});
      _Object$entries(payload).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            value = _ref4[1];

        console.log("NAME ", name);
        console.log("VALUE ", value);
        fd.append(name, value);
      });
      console.log("REQUEST ", request);
      console.log("FD ", fd);
      request.send(fd);
    });
  },
  sendFile: function sendFile(file, config, is_sending_s3) {
    var handler = is_sending_s3 ? this.setResponseHandler : this.sendS3Handler;

    return this.getSignedURL(file, config).then(function (response) {
      return handler(response, file);
    }).catch(function (error) {
      return error;
    });
  },
  setResponseHandler: function setResponseHandler(response, file) {
    file.s3Signature = response.signature;
    file.s3Url = response.postEndpoint;
  },
  sendS3Handler: function sendS3Handler(response, file) {
    var fd = new FormData(),
        signature = response.signature;
    _Object$keys(signature).forEach(function (key) {
      fd.append(key, signature[key]);
    });
    fd.append("file", file);
    return new _Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open("POST", response.postEndpoint);
      request.onload = function () {
        if (request.status == 201) {
          var s3Error = new window.DOMParser().parseFromString(request.response, "text/xml");
          var successMsg = s3Error.firstChild.children[0].innerHTML;
          resolve({
            success: true,
            message: successMsg
          });
        } else {
          var s3Error = new window.DOMParser().parseFromString(request.response, "text/xml");
          var errMsg = s3Error.firstChild.children[0].innerHTML;
          reject({
            success: false,
            message: errMsg + ". Request is marked as resolved when returns as status 201"
          });
        }
      };
      request.onerror = function (err) {
        var s3Error = new window.DOMParser().parseFromString(request.response, "text/xml");
        var errMsg = s3Error.firstChild.children[1].innerHTML;
        reject({
          success: false,
          message: errMsg
        });
      };
      request.send(fd);
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/dropzone/urlsigner.js
// module id = ./src/components/shared/dropzone/urlsigner.js
// module chunks = 0 1 2 3